import apiCall, { makeUrl } from "../../utils/apiCall";

export function* onboardConnectAccount() {
  const customerPortalSessionCall = yield apiCall();
  const result = yield customerPortalSessionCall.get(makeUrl("/stripe-connect/onboard"));
  window.location = result.data.url;
}
